var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270,
    height: 140,
    viewBox: "0 0 270 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.d{fill:#872634;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 270,
    height: 140
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.236 9.126)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M130.183,93.883H65.147L56.8,36.736,71.2,11.419a1.806,1.806,0,0,1,3.119,0L85.052,30.958a1.75,1.75,0,0,0,2.568.55l3.486-2.568a1.736,1.736,0,0,1,2.568.55l36.508,64.394",
    transform: "translate(-56.341 -10.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M130.967,94.3H64.739L56.3,36.6,70.793,11.1a2.192,2.192,0,0,1,3.853.092L85.378,30.731a1.16,1.16,0,0,0,.917.642,1.579,1.579,0,0,0,1.1-.183l3.486-2.568a2.2,2.2,0,0,1,1.835-.367,2.021,2.021,0,0,1,1.468,1.1Zm-65.4-.917h63.843L93.358,29.722a1.16,1.16,0,0,0-.917-.642,1.579,1.579,0,0,0-1.1.183l-3.486,2.568a2.2,2.2,0,0,1-1.835.367,2.021,2.021,0,0,1-1.468-1.1L73.912,11.651a1.2,1.2,0,0,0-1.1-.642,1.568,1.568,0,0,0-1.192.642l-14.4,25.134Z",
    transform: "translate(-56.3 -10)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.669 19.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M82.812,94.244,44.836,23.613a1.744,1.744,0,0,0-3.119,0L4.2,94.886",
    transform: "translate(-3.741 -22.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4.526,95.024,3.7,94.566,41.217,23.292A2.178,2.178,0,0,1,43.235,22.1h0a2.391,2.391,0,0,1,2.018,1.192L83.229,93.924l-.826.459L44.428,23.751a1.322,1.322,0,0,0-1.192-.734h0a1.431,1.431,0,0,0-1.192.734Z",
    transform: "translate(-3.7 -22.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.83 38.802)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M44.49,51.973a2.148,2.148,0,0,1-1.559-.642L34.4,43.442l.642-.642,8.531,7.889a1.26,1.26,0,0,0,1.651.092L50.086,47.2a2.208,2.208,0,0,1,3.119.459l2.2,2.844a1.4,1.4,0,0,0,1.835.275l2.568-1.835.55.734-2.568,1.835a2.181,2.181,0,0,1-3.027-.459l-2.2-2.844a1.418,1.418,0,0,0-1.835-.275l-4.862,3.577A2.073,2.073,0,0,1,44.49,51.973Z",
    transform: "translate(-34.4 -42.8)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.967 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M93.9,9.218a.284.284,0,0,1,.092.183,2.925,2.925,0,0,0,2.66,2.293h10.182a4.261,4.261,0,0,0,2.11-.55,3.577,3.577,0,0,0,1.651-3.394,3.518,3.518,0,0,0-2.66-3.027c-.183-.092-.183-.092-.183-.183a3.616,3.616,0,0,0-.917-2.477A3.714,3.714,0,0,0,104.265.6a3.951,3.951,0,0,0-4.311,2.385,1.326,1.326,0,0,0-.183.642c0,.092-.092.092-.183.092a2.823,2.823,0,0,0-2.568.092A2.615,2.615,0,0,0,95.735,6.1c0,.092,0,.183-.183.183a2.924,2.924,0,0,0-1.651,2.2v.734Z",
    transform: "translate(-93.35 -0.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M106.784,12.112H96.51a3.317,3.317,0,0,1-3.119-2.66h0L93.3,9.361V8.168h.092a3.5,3.5,0,0,1,1.835-2.293,3.132,3.132,0,0,1,1.468-2.568,3.363,3.363,0,0,1,2.66-.275c0-.092.092-.183.092-.275A4.5,4.5,0,0,1,104.216.1a4.767,4.767,0,0,1,2.935,1.651,4.908,4.908,0,0,1,1.009,2.568,3.942,3.942,0,0,1,2.752,3.394,3.919,3.919,0,0,1-1.835,3.853A4.468,4.468,0,0,1,106.784,12.112Zm-4.036-.917h4.036a3.613,3.613,0,0,0,1.835-.459,3.119,3.119,0,0,0,1.468-3.027,3.018,3.018,0,0,0-2.293-2.66.626.626,0,0,1-.459-.642,3.732,3.732,0,0,0-.734-2.2A4,4,0,0,0,104.307.83a3.522,3.522,0,0,0-3.853,2.11,1.55,1.55,0,0,0-.183.459.78.78,0,0,1-.275.459,1.051,1.051,0,0,1-.55,0,2.986,2.986,0,0,0-2.2.183,2.236,2.236,0,0,0-1.1,1.926.69.69,0,0,1-.459.642,2.483,2.483,0,0,0-1.468,1.835v.642c0,.092.092.183.092.275a2.433,2.433,0,0,0,2.2,1.926h4.036A17.675,17.675,0,0,1,102.748,11.2Z",
    transform: "translate(-93.3 -0.051)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.03 12.38)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M128.65,21.344c-.092.092,0,.092-.092.183a2.543,2.543,0,0,1-2.2,1.926h-8.439A2.987,2.987,0,0,1,117,17.583c.092,0,.092-.092.092-.183a3.205,3.205,0,0,1,.734-2.018,3.4,3.4,0,0,1,2.2-1.284,3.331,3.331,0,0,1,3.577,2.018c.092.183.092.367.183.459,0,.092.092.092.183.092a2.154,2.154,0,0,1,2.11.092,2.357,2.357,0,0,1,1.1,1.926c0,.092,0,.183.092.183A2.37,2.37,0,0,1,128.65,20.7v.642Z",
    transform: "translate(-114.329 -13.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M117.876,23.778a3.488,3.488,0,0,1-2.018-.55,3.445,3.445,0,0,1-1.559-3.3,3.263,3.263,0,0,1,2.293-2.844,4.264,4.264,0,0,1,.826-2.11,3.418,3.418,0,0,1,2.477-1.376,3.942,3.942,0,0,1,4.128,2.2c0,.092.092.092.092.183a2.388,2.388,0,0,1,2.2.275,2.512,2.512,0,0,1,1.284,2.11,2.7,2.7,0,0,1,1.468,1.835h.092v1.192l-.092.092a2.925,2.925,0,0,1-2.66,2.293h-8.531Zm2.568-9.356h-.459a2.6,2.6,0,0,0-1.835,1.1,3.128,3.128,0,0,0-.642,1.743c0,.459-.275.55-.459.55a2.344,2.344,0,0,0-1.835,2.2,2.52,2.52,0,0,0,2.66,2.752h8.531a1.941,1.941,0,0,0,1.835-1.559v-.734a1.963,1.963,0,0,0-1.1-1.468.5.5,0,0,1-.367-.55,1.7,1.7,0,0,0-.826-1.559,1.542,1.542,0,0,0-1.651-.092.585.585,0,0,1-.55,0c-.092-.092-.275-.183-.275-.367a.7.7,0,0,0-.183-.367A3.352,3.352,0,0,0,120.445,14.421Z",
    transform: "translate(-114.288 -13.547)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.275 9.169)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.492,32.825v.092a1.863,1.863,0,0,0,1.559,1.376H8.013A2.293,2.293,0,0,0,9.3,33.926a1.983,1.983,0,0,0,.917-2.018,2.165,2.165,0,0,0-1.559-1.835.09.09,0,0,1-.092-.092,2.249,2.249,0,0,0-.55-1.468A2.478,2.478,0,0,0,6.454,27.6a2.343,2.343,0,0,0-2.568,1.376.551.551,0,0,0-.092.367c0,.092,0,.092-.092.092a1.4,1.4,0,0,0-1.468.092A1.509,1.509,0,0,0,1.5,30.9c0,.092,0,.092-.092.092A1.624,1.624,0,0,0,.4,32.275v.092A.827.827,0,0,1,.492,32.825Z",
    transform: "translate(-0.033 -27.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.072,34.719H2.018A2.15,2.15,0,0,1,0,33.068v-1.1H.092A2.372,2.372,0,0,1,1.1,30.683,1.994,1.994,0,0,1,2.11,29.124a2.126,2.126,0,0,1,1.468-.275h0A2.834,2.834,0,0,1,6.6,27.2a2.6,2.6,0,0,1,1.835,1.1,3.015,3.015,0,0,1,.642,1.468,2.484,2.484,0,0,1,1.651,2.11A2.556,2.556,0,0,1,9.54,34.352,3.126,3.126,0,0,1,8.072,34.719ZM5.779,33.8H8.164a1.849,1.849,0,0,0,1.009-.275,1.549,1.549,0,0,0,.734-1.559,1.568,1.568,0,0,0-1.192-1.376c-.275-.092-.367-.275-.459-.55A1.932,1.932,0,0,0,7.8,28.848,1.874,1.874,0,0,0,6.6,28.114a2.033,2.033,0,0,0-2.11,1.1c0,.092-.092.183-.092.275l-.092.183-.275.183a.417.417,0,0,1-.459,0,.975.975,0,0,0-1.1.092,1.054,1.054,0,0,0-.55,1.009.5.5,0,0,1-.367.55,1.089,1.089,0,0,0-.734.917v.459a1.09,1.09,0,0,0,1.1.917H5.779Zm-5.32-.917H0v.092Zm8.622-2.935Zm-.275-.275Z",
    transform: "translate(0 -27.166)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.804)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.15,17.844c-.092.092,0,.092-.092.183a2.543,2.543,0,0,1-2.2,1.926H14.418a2.987,2.987,0,0,1-.917-5.871c.092,0,.092-.092.092-.183a3.206,3.206,0,0,1,.734-2.018,3.4,3.4,0,0,1,2.2-1.284A3.331,3.331,0,0,1,20.1,12.616c.092.183.092.367.183.459,0,.092.092.092.183.092a2.154,2.154,0,0,1,2.11.092,2.357,2.357,0,0,1,1.1,1.926c0,.092,0,.183.092.183A2.37,2.37,0,0,1,25.15,17.2v.092Q25.15,17.431,25.15,17.844Z",
    transform: "translate(-10.737 -10.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.276,20.278a3.488,3.488,0,0,1-2.018-.55,3.445,3.445,0,0,1-1.559-3.3,3.263,3.263,0,0,1,2.293-2.844,4.264,4.264,0,0,1,.826-2.11A3.418,3.418,0,0,1,16.294,10.1a3.942,3.942,0,0,1,4.128,2.2c0,.092.092.092.092.183a2.388,2.388,0,0,1,2.2.275A2.512,2.512,0,0,1,24,14.866,2.7,2.7,0,0,1,25.467,16.7h.092v1.192l-.092.092a2.925,2.925,0,0,1-2.66,2.293H14.276Zm2.66-9.356h-.459a2.6,2.6,0,0,0-1.835,1.1A3.128,3.128,0,0,0,14,13.765c0,.459-.275.55-.459.55a2.344,2.344,0,0,0-1.835,2.2,2.52,2.52,0,0,0,2.66,2.752h8.439a1.941,1.941,0,0,0,1.835-1.559v-.734a1.963,1.963,0,0,0-1.1-1.468.5.5,0,0,1-.367-.55,1.7,1.7,0,0,0-.826-1.559,1.542,1.542,0,0,0-1.651-.092.585.585,0,0,1-.55,0c-.183-.092-.275-.183-.275-.367a.7.7,0,0,0-.183-.367A3.1,3.1,0,0,0,16.937,10.921Z",
    transform: "translate(-10.688 -10.047)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.832 16.556)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.75 22.966)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M280.667,46.956a.693.693,0,0,1-.367-.642V43.745a.555.555,0,0,1,.275-.55c.275-.183.642.092.642.459V46.5c0,.275-.183.367-.367.459Z",
    transform: "translate(-280.3 -43.136)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.146 6.238)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M280.255,24.9a7.155,7.155,0,1,1-7.155,7.155A7.164,7.164,0,0,1,280.255,24.9Zm0,13.392a6.192,6.192,0,1,0,.092-12.383,6.192,6.192,0,0,0-.092,12.383Z",
    transform: "translate(-273.1 -24.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.647 17.956)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M271.594,38.248c-.092.092-.092.275-.275.275-.734.459-1.559.917-2.385,1.376a.472.472,0,1,1-.459-.826c.826-.459,1.559-.917,2.385-1.376A.548.548,0,0,1,271.594,38.248Z",
    transform: "translate(-268.196 -37.675)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.708 6.513)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M268.755,25.2c.092,0,.183.092.275.092.734.459,1.468.826,2.2,1.284.275.183.459.459.275.734a.478.478,0,0,1-.734.092c-.734-.459-1.468-.826-2.2-1.284q-.413-.275-.275-.55C268.3,25.292,268.48,25.2,268.755,25.2Z",
    transform: "translate(-268.262 -25.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.522 6.413)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M290.447,27.484a.5.5,0,0,1-.55-.367.385.385,0,0,1,.275-.55l1.376-.826a8.065,8.065,0,0,1,.917-.55.555.555,0,0,1,.734.092c.183.275.092.55-.275.734a18.466,18.466,0,0,1-2.293,1.284C290.631,27.484,290.539,27.484,290.447,27.484Z",
    transform: "translate(-289.862 -25.091)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.943 1.743)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M288.29,20.55c0,.092-.092.183-.092.275-.459.734-.826,1.468-1.284,2.2a.615.615,0,0,1-.734.275.478.478,0,0,1-.092-.734c.459-.734.826-1.468,1.284-2.293a.654.654,0,0,1,.55-.275A.619.619,0,0,1,288.29,20.55Z",
    transform: "translate(-285.961 -20)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.385 21.624)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M275.69,42.248c0,.092-.092.183-.092.275-.459.734-.826,1.468-1.284,2.2a.615.615,0,0,1-.734.275.478.478,0,0,1-.092-.734c.459-.734.826-1.468,1.284-2.293a.445.445,0,0,1,.55-.275C275.6,41.881,275.69,41.973,275.69,42.248Z",
    transform: "translate(-273.361 -41.673)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.909 21.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M286.452,41.8c.092.092.275.092.367.275.459.734.917,1.559,1.376,2.385a.394.394,0,0,1-.183.642c-.275.092-.55.092-.642-.183-.459-.826-.917-1.559-1.376-2.385A.476.476,0,0,1,286.452,41.8Z",
    transform: "translate(-285.923 -41.8)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.624 17.979)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M290.456,37.7c.092,0,.183.092.275.092.734.459,1.468.826,2.2,1.284.367.183.459.459.275.734a.478.478,0,0,1-.734.092c-.734-.459-1.468-.826-2.2-1.284a.445.445,0,0,1-.275-.55A.42.42,0,0,1,290.456,37.7Z",
    transform: "translate(-289.973 -37.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.363 1.743)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M273.853,20c.092.092.275.183.367.275.459.734.917,1.559,1.376,2.385a.394.394,0,0,1-.183.642c-.275.092-.55.092-.642-.183-.459-.826-.917-1.559-1.376-2.385A.522.522,0,0,1,273.853,20Z",
    transform: "translate(-273.336 -20)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.842)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M281.317,20.026v1.284c0,.367-.183.55-.459.55s-.459-.183-.459-.55V18.65c0-.367.183-.55.459-.55s.459.183.459.55Z",
    transform: "translate(-280.4 -18.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.934)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M268.235,33.117H266.95c-.367,0-.55-.183-.55-.459s.183-.459.55-.459h2.568c.367,0,.55.183.55.459s-.183.459-.55.459Z",
    transform: "translate(-266.4 -32.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.932 12.934)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M293.235,33.117H291.95c-.367,0-.55-.183-.55-.459s.183-.459.55-.459h2.66a.514.514,0,0,1,.55.459c0,.275-.184.459-.55.459Z",
    transform: "translate(-291.4 -32.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.113 61.14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M154.691,91.783c5.687,7.98,14.952,8.256,21.831,0C186.154,80.408,165.974,68.3,165.974,68.3,153.04,77.014,149.463,84.444,154.691,91.783Z",
    transform: "translate(-151.946 -67.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M165.2,98.246h-.459c-3.944-.183-7.705-2.385-10.457-6.238h0a10.962,10.962,0,0,1-2.2-8.622c.917-4.862,5.32-9.907,13.668-15.5l.275-.183.275.183c.459.275,11.833,7.155,13.209,15.594a10.072,10.072,0,0,1-2.568,8.531C173.457,96.044,169.329,98.246,165.2,98.246Zm-10.182-6.788c2.568,3.669,6.054,5.687,9.723,5.871,3.944.183,8.072-1.926,11.374-5.871a9.406,9.406,0,0,0,2.385-7.8c-1.192-7.338-10.916-13.759-12.567-14.86-7.889,5.32-12.108,10.182-12.934,14.768-.55,2.66.183,5.229,2.018,7.889Z",
    transform: "translate(-151.907 -67.7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.386 14.86)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M166.959,112.886a.433.433,0,0,1-.459-.459V84.359a.459.459,0,0,1,.917,0v28.069A.491.491,0,0,1,166.959,112.886Z",
    transform: "translate(-166.5 -83.9)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.192 72.619)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M177.258,97.028c3.944,5.6,10.457,5.687,15.227,0,6.7-7.98-7.338-16.328-7.338-16.328C176.157,86.662,173.681,91.891,177.258,97.028Z",
    transform: "translate(-175.129 -80.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M184.546,101.667h-.367c-2.844-.092-5.412-1.651-7.43-4.4h0a8.016,8.016,0,0,1-1.559-6.054c.642-3.394,3.761-6.971,9.54-10.916a.409.409,0,0,1,.459,0c.367.183,8.347,5.045,9.265,11.007a7.2,7.2,0,0,1-1.835,6.054A10.561,10.561,0,0,1,184.546,101.667Zm.55-20.547c-5.412,3.669-8.347,7.063-8.9,10.182a6.778,6.778,0,0,0,1.376,5.412h0a8.7,8.7,0,0,0,6.7,4.036c2.752.092,5.5-1.376,7.8-4.036a6.543,6.543,0,0,0,1.651-5.32C192.894,86.348,186.473,82.037,185.1,81.119Z",
    transform: "translate(-175.079 -80.225)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.036 7.749)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.348)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M172.559,92.873a.433.433,0,0,1-.459-.459V71.959a.459.459,0,1,1,.917,0V92.414A.433.433,0,0,1,172.559,92.873Z",
    transform: "translate(-172.1 -71.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.38 3.334)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M172.561,80.056a.337.337,0,0,1-.275-.092.565.565,0,0,1-.092-.642l3.3-4.036a.459.459,0,0,1,.734.55l-3.3,4.036A.477.477,0,0,1,172.561,80.056Z",
    transform: "translate(-172.134 -75.134)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.055)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M172.257,76.915a.551.551,0,0,1-.367-.092l-3.3-3.394a.454.454,0,0,1,.642-.642l3.3,3.394a.443.443,0,0,1,0,.642A.924.924,0,0,1,172.257,76.915Z",
    transform: "translate(-168.45 -72.65)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.275 100.416)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.614,138.969a.551.551,0,0,1-.367-.092.443.443,0,0,1,0-.642,2.537,2.537,0,0,0,.55-2.935,2.694,2.694,0,0,0-2.477-1.651H103.562a3.7,3.7,0,0,1-3.394-2.2,3.373,3.373,0,0,1,.826-3.944,2.537,2.537,0,0,0,.55-2.935,2.694,2.694,0,0,0-2.477-1.651H76.96a3.7,3.7,0,0,1-3.394-2.2,3.518,3.518,0,0,1,.826-3.944l.367-.367a2.537,2.537,0,0,0,.55-2.935,2.694,2.694,0,0,0-2.477-1.651H.459a.459.459,0,0,1,0-.917H72.833a3.7,3.7,0,0,1,3.394,2.2,3.518,3.518,0,0,1-.826,3.944l-.367.367a2.537,2.537,0,0,0-.55,2.935A2.694,2.694,0,0,0,76.96,122H99.067a3.7,3.7,0,0,1,3.394,2.2,3.373,3.373,0,0,1-.826,3.944,2.537,2.537,0,0,0-.55,2.935,2.694,2.694,0,0,0,2.477,1.651h13.759a3.7,3.7,0,0,1,3.394,2.2,3.518,3.518,0,0,1-.826,3.944C119.8,138.877,119.706,138.969,119.614,138.969Z",
    transform: "translate(0 -110.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.207 54.382)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M267.774,73.759a1.77,1.77,0,0,1-.275.917,1.617,1.617,0,0,1-1.376.734,1.77,1.77,0,0,1-.917-.275l-17.52-11.558-17.52,11.558a1.592,1.592,0,0,1-1.284.275,1.42,1.42,0,0,1-1.009-.734,1.592,1.592,0,0,1-.275-1.284,1.42,1.42,0,0,1,.734-1.009l18.437-12.108a1.77,1.77,0,0,1,.917-.275,1.55,1.55,0,0,1,.917.275L267.04,72.383A1.887,1.887,0,0,1,267.774,73.759Z",
    transform: "translate(-227.562 -60)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.902 63.358)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.251,92.29h-9.173a2.436,2.436,0,0,1-2.018-1.009,2.357,2.357,0,0,1-.275-2.2l.55-1.651a2.4,2.4,0,0,1-.55-2.568l4.586-13.209A2.452,2.452,0,0,1,104.665,70a2.367,2.367,0,0,1,2.293,1.651l4.586,13.209a2.634,2.634,0,0,1-.55,2.568l.55,1.651a2.357,2.357,0,0,1-.275,2.2A2.7,2.7,0,0,1,109.251,92.29Zm-4.586-21.373a1.526,1.526,0,0,0-1.468,1.009L98.611,85.135a1.616,1.616,0,0,0,.55,1.743l.275.183-.826,2.293a1.463,1.463,0,0,0,.183,1.376,1.6,1.6,0,0,0,1.284.642h9.173a1.927,1.927,0,0,0,1.284-.642,1.463,1.463,0,0,0,.183-1.376l-.826-2.293.275-.183a1.569,1.569,0,0,0,.55-1.743l-4.586-13.209A1.526,1.526,0,0,0,104.665,70.917Z",
    transform: "translate(-97.621 -70)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.585 17.153)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M105.259,100.625a.433.433,0,0,1-.459-.459V89.159a.459.459,0,1,1,.917,0v11.007A.433.433,0,0,1,105.259,100.625Z",
    transform: "translate(-104.8 -88.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.54 73.586)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M123.291,92.518a1.263,1.263,0,0,0,.459-1.468l-2.935-8.531a1.242,1.242,0,0,0-2.385,0l-2.935,8.531a1.306,1.306,0,0,0,.459,1.468l-.459,1.284a1.339,1.339,0,0,0,1.192,1.743h5.871a1.271,1.271,0,0,0,1.192-1.743Z",
    transform: "translate(-114.875 -81.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M122.416,95.968h-5.871a1.617,1.617,0,0,1-1.376-.734,1.389,1.389,0,0,1-.183-1.559l.367-1.009a1.712,1.712,0,0,1-.367-1.743l2.935-8.531a1.739,1.739,0,0,1,3.3,0l2.935,8.531a1.712,1.712,0,0,1-.367,1.743l.367,1.009a1.85,1.85,0,0,1-.183,1.559A2.1,2.1,0,0,1,122.416,95.968ZM119.48,82.117a.769.769,0,0,0-.734.55L115.811,91.2a.83.83,0,0,0,.275.917l.275.183-.55,1.559a.692.692,0,0,0,.092.734.929.929,0,0,0,.642.367h5.871a.614.614,0,0,0,.642-.367.693.693,0,0,0,.092-.734L122.6,92.3l.275-.183a.713.713,0,0,0,.275-.917l-2.935-8.531A.769.769,0,0,0,119.48,82.117Z",
    transform: "translate(-114.826 -81.2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.196 11.191)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 7.155,
    transform: "translate(0.459 0.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.859,101.38a.433.433,0,0,1-.459-.459V93.859a.459.459,0,1,1,.917,0v7.063A.491.491,0,0,1,119.859,101.38Z",
    transform: "translate(-119.4 -93.4)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M285.2,97.612v-.55c0-6.513-1.908-11.374-4.451-11.374a2.45,2.45,0,0,0-1.908,1.009c-.818-4.128-2.453-6.7-4.36-6.7-2.816,0-4.905,5.6-4.905,12.842a35.5,35.5,0,0,0,.454,5.5c-.545.092-1.09.092-1.726.183-.272-4.862-1.817-9.54-4.36-9.54-2.362,0-4.178,4.495-4.36,10.457-6,.275-15.079.459-24.616.642-20.529.459-43.873.917-53.684,2.477-32.792,5.32-44.055,13.117-44.509,13.484-.091.092-.182.183-.182.275H126.415a2.944,2.944,0,0,1-2.089-.917,3.173,3.173,0,0,1-.727-1.926,2.5,2.5,0,0,1,1-1.835l6.9-5.687a3.572,3.572,0,0,0,1.363-2.844,3.663,3.663,0,0,0-3.724-3.577h0l-78.118-.183c1.181-1.009,2.725-4.128-.091-3.944a.089.089,0,0,1-.091-.092c.454-2.66-.636-3.669-3.179-3.761-.091,0-.091,0-.091-.092.091-1.651,0-2.935-1.635-3.761a2.282,2.282,0,0,0-2.907.275c-.091.092-.091,0-.091-.092.818-2.752-5.9-4.036-6.268-.092a.09.09,0,0,1-.091.092c-.273-.459-1.181-1.376-2.18-.917a1.97,1.97,0,0,0-1,1.743s-.091.092-.091,0c-1.635-.917-4-.917-3.906,1.468a.09.09,0,0,1-.091.092,4.048,4.048,0,0,0-2.725-.459,3.734,3.734,0,0,0-1.363.642c-.363.642-.091,1.284-.363,1.651-.182.367-1.635.092-2.18.917a2.425,2.425,0,0,0-.091,2.477c0,.092,0,.092-.091.092-2.089-.917-3.452,1.926-3.633,3.577H.154a.459.459,0,0,0,0,.917l128.8.275h0a2.749,2.749,0,0,1,2.816,2.66,2.578,2.578,0,0,1-1.09,2.11l-6.9,5.687a3.694,3.694,0,0,0-.363,5.229,4.471,4.471,0,0,0,2.725,1.284l158.235.55h.182a.089.089,0,0,0,.091-.092h.091a.09.09,0,0,1,.091-.092v-.275h0Z",
    transform: "translate(0.3 -7.928)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.343 58.791)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M92.776,79.4a.477.477,0,0,1-.367.183H90.942l-.092,18.8a.433.433,0,0,1-.459.459h-46.6a.433.433,0,0,1-.459-.459v-18.8H41.959a.477.477,0,0,1-.367-.183.551.551,0,0,1-.092-.367l4.128-13.759A.5.5,0,0,1,46.086,65h42.2a.5.5,0,0,1,.459.275l4.128,13.668A.827.827,0,0,1,92.776,79.4Z",
    transform: "translate(-41.5 -65)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.394 5.229)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M82.981,80.331l-14.31-9.448a1.3,1.3,0,0,0-.55-.183.674.674,0,0,0-.55.183l-14.31,9.448a.9.9,0,0,0-.275,1.284h0a.9.9,0,0,0,1.284.275l13.851-9.173,13.851,9.173a.9.9,0,0,0,1.284-.275h0A1.1,1.1,0,0,0,82.981,80.331Z",
    transform: "translate(-52.831 -70.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.29 10.916)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M69.194,83.688a3.394,3.394,0,1,1,3.394-3.394A3.386,3.386,0,0,1,69.194,83.688Zm0-5.871a2.477,2.477,0,1,0,2.477,2.477A2.466,2.466,0,0,0,69.194,77.817Z",
    transform: "translate(-65.8 -76.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.225 10.824)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M69.459,83.68A.433.433,0,0,1,69,83.221V77.259a.459.459,0,1,1,.917,0v5.962A.433.433,0,0,1,69.459,83.68Z",
    transform: "translate(-69 -76.8)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.198 13.851)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M72.121,81.017H66.159a.459.459,0,1,1,0-.917h5.962a.459.459,0,0,1,0,.917Z",
    transform: "translate(-65.7 -80.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.135 12.842)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M78.455,100.006h-20A.433.433,0,0,1,58,99.547V79.459a.459.459,0,1,1,.917,0V99H78.089V79.459a.459.459,0,1,1,.917,0V99.547C78.914,99.731,78.731,100.006,78.455,100.006Z",
    transform: "translate(-58 -79)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M92.409,79.585H80.118a.459.459,0,1,1,0-.917h11.65l-3.853-12.75H46.453L42.6,78.668H54.159a.459.459,0,0,1,0,.917h-12.2a.477.477,0,0,1-.367-.183.551.551,0,0,1-.092-.367l4.128-13.668A.609.609,0,0,1,46.086,65h42.2a.468.468,0,0,1,.459.367l4.128,13.668c0,.183,0,.275-.092.367A.7.7,0,0,1,92.409,79.585Z",
    transform: "translate(-41.5 -65)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.835 13.668)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M90.557,100.08h-46.6a.433.433,0,0,1-.459-.459V80.359a.459.459,0,0,1,.917,0v18.8H90.1l.092-18.8a.433.433,0,0,1,.459-.459h0a.433.433,0,0,1,.459.459l-.092,19.263A.589.589,0,0,1,90.557,100.08Z",
    transform: "translate(-43.5 -79.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.465 20.822)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M72.605,100.725a.433.433,0,0,1-.459-.459V88.617H65.817v11.466a.459.459,0,1,1-.917,0V88.159a.433.433,0,0,1,.459-.459h7.247a.433.433,0,0,1,.459.459v12.108A.491.491,0,0,1,72.605,100.725Z",
    transform: "translate(-64.9 -87.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.779 17.887)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M53.579,93.4h-5.32a.433.433,0,0,1-.459-.459v-7.98a.433.433,0,0,1,.459-.459h5.32a.433.433,0,0,1,.459.459v7.98A.491.491,0,0,1,53.579,93.4Zm-4.862-.917h4.4V85.417h-4.4Z",
    transform: "translate(-47.8 -84.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.076 17.887)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M89.879,93.4h-5.32a.433.433,0,0,1-.459-.459v-7.98a.433.433,0,0,1,.459-.459h5.32a.433.433,0,0,1,.459.459v7.98A.491.491,0,0,1,89.879,93.4Zm-4.862-.917h4.4V85.417h-4.4Z",
    transform: "translate(-84.1 -84.5)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.866 82.826)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M223.674,99.38a1.7,1.7,0,0,1-.183.642.935.935,0,0,1-.734.459.88.88,0,0,1-.826-.183l-.092-.092V111.03a.433.433,0,0,1-.459.459h-18.8a.433.433,0,0,1-.459-.459V100.206l-.183.092a1.326,1.326,0,0,1-.642.183h-.275a2,2,0,0,1-.734-.459,1.09,1.09,0,0,1,.367-1.559l10.641-6.88a1.7,1.7,0,0,1,.642-.183,1.326,1.326,0,0,1,.642.183l10.641,6.88A1.129,1.129,0,0,1,223.674,99.38Z",
    transform: "translate(-200.092 -91.4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M201.292,100.481h-.275a2,2,0,0,1-.734-.459,1.09,1.09,0,0,1,.367-1.559l10.641-6.88a1.7,1.7,0,0,1,.642-.183,1.326,1.326,0,0,1,.642.183l10.641,6.88h0a1.19,1.19,0,0,1,.367,1.559.935.935,0,0,1-.734.459.88.88,0,0,1-.826-.183l-10.09-6.513-10,6.513A.774.774,0,0,1,201.292,100.481Zm10.641-8.164h-.092L201.2,99.2a.337.337,0,0,0-.092.275.09.09,0,0,0,.092.092h.183l10.274-6.7a.585.585,0,0,1,.55,0l10.274,6.7h.183a.09.09,0,0,0,.092-.092c.092-.092,0-.183-.092-.275l-10.641-6.88Z",
    transform: "translate(-200.092 -91.4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.006 4.862)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M212.835,100.186A1.823,1.823,0,0,1,211,98.443a1.764,1.764,0,0,1,1.835-1.743,1.745,1.745,0,1,1,0,3.486Zm0-2.66a.826.826,0,1,0,.826.826A.822.822,0,0,0,212.835,97.526Z",
    transform: "translate(-211 -96.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.025 7.522)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M221.563,112.259h-18.8a.433.433,0,0,1-.459-.459V100.059a.459.459,0,1,1,.917,0v11.283h17.8V100.059a.459.459,0,1,1,.917,0V111.8C222.022,112.075,221.838,112.259,221.563,112.259Z",
    transform: "translate(-202.3 -99.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.144 9.815)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M218.634,112.19a.433.433,0,0,1-.459-.459v-8.714H206.617v8.714a.459.459,0,1,1-.917,0v-9.173a.433.433,0,0,1,.459-.459h12.475a.433.433,0,0,1,.459.459v9.173A.433.433,0,0,1,218.634,112.19Z",
    transform: "translate(-205.7 -102.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.236 11.191)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M218.642,104.334H206.167a.367.367,0,1,1,0-.734h12.475a.367.367,0,0,1,0,.734Z",
    transform: "translate(-205.8 -103.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.236 12.567)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M218.642,105.834H206.167a.367.367,0,1,1,0-.734h12.475a.367.367,0,0,1,0,.734Z",
    transform: "translate(-205.8 -105.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.236 13.943)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M218.642,107.334H206.167a.367.367,0,1,1,0-.734h12.475a.367.367,0,0,1,0,.734Z",
    transform: "translate(-205.8 -106.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.236 15.319)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M218.642,108.834H206.167a.367.367,0,1,1,0-.734h12.475a.367.367,0,0,1,0,.734Z",
    transform: "translate(-205.8 -108.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.236 16.695)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M218.642,110.334H206.167a.367.367,0,1,1,0-.734h12.475a.367.367,0,0,1,0,.734Z",
    transform: "translate(-205.8 -109.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.236 18.071)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M218.642,111.834H206.167a.367.367,0,1,1,0-.734h12.475a.367.367,0,0,1,0,.734Z",
    transform: "translate(-205.8 -111.1)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.241 53.635)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M264.842,74.852V88.611l2.477,6.6c.092.183,0,.275-.092.459a.7.7,0,0,1-.367.183h-2.11V115.4a.433.433,0,0,1-.459.459h-33.3a.433.433,0,0,1-.459-.459V95.858h-2.11a.477.477,0,0,1-.367-.183.687.687,0,0,1-.092-.459l2.477-6.6a.09.09,0,0,1,.092-.092V74.944l-.367.183a1.592,1.592,0,0,1-1.284.275,1.42,1.42,0,0,1-1.009-.734,2.048,2.048,0,0,1-.275-1.284,1.42,1.42,0,0,1,.734-1.009l5.045-3.394V62.652a1.363,1.363,0,0,1-.734-1.284h0a1.449,1.449,0,0,1,1.468-1.468h4.22a1.449,1.449,0,0,1,1.468,1.468h0a1.568,1.568,0,0,1-.642,1.192v2.66l7.613-5.045a1.77,1.77,0,0,1,.917-.275,1.55,1.55,0,0,1,.917.275l18.437,12.108a1.617,1.617,0,0,1,.734,1.376,1.77,1.77,0,0,1-.275.917,1.617,1.617,0,0,1-1.376.734,1.77,1.77,0,0,1-.917-.275Z",
    transform: "translate(-227.6 -59.9)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.057 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.092)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M266.223,75.41a1.77,1.77,0,0,1-.917-.275l-17.52-11.558-17.52,11.558a1.592,1.592,0,0,1-1.284.275,1.42,1.42,0,0,1-1.009-.734,1.592,1.592,0,0,1-.275-1.284,1.42,1.42,0,0,1,.734-1.009l18.437-12.108a1.77,1.77,0,0,1,.917-.275,1.55,1.55,0,0,1,.917.275L267.14,72.383h0a1.634,1.634,0,0,1,.459,2.293A1.618,1.618,0,0,1,266.223,75.41ZM247.785,62.568a.337.337,0,0,1,.275.092l17.8,11.741a.661.661,0,1,0,.734-1.1L248.152,61.192a.551.551,0,0,0-.367-.092h0c-.183,0-.275,0-.367.092L228.981,73.3a.5.5,0,0,0-.275.459,1.164,1.164,0,0,0,.092.55.5.5,0,0,0,.459.275,1.164,1.164,0,0,0,.55-.092l17.8-11.741C247.6,62.568,247.694,62.568,247.785,62.568Z",
    transform: "translate(-227.662 -60)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.97 13.576)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M264.656,90.477h-33.3a.433.433,0,0,1-.459-.459V75.342a.459.459,0,0,1,.917,0V89.56H264.2v-14.4a.459.459,0,0,1,.917,0V89.927C265.115,90.294,264.931,90.477,264.656,90.477Z",
    transform: "translate(-230.9 -74.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.97 35.04)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M264.656,119.014h-33.3a.433.433,0,0,1-.459-.459V98.65a.459.459,0,0,1,.917,0V118.1H264.2V98.559a.459.459,0,0,1,.917,0v20A.433.433,0,0,1,264.656,119.014Z",
    transform: "translate(-230.9 -98.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.454 7.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M249.177,75.155a3.577,3.577,0,1,1,3.577-3.577A3.524,3.524,0,0,1,249.177,75.155Zm0-6.329a2.66,2.66,0,1,0,2.66,2.66A2.662,2.662,0,0,0,249.177,68.826Z",
    transform: "translate(-245.6 -68)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.573 7.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M249.459,75.155A.433.433,0,0,1,249,74.7V68.459a.459.459,0,0,1,.917,0V74.7C250.009,74.88,249.734,75.155,249.459,75.155Z",
    transform: "translate(-249 -68)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.454 10.457)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M252.3,72.217h-6.238a.459.459,0,0,1,0-.917H252.3a.459.459,0,1,1,0,.917Z",
    transform: "translate(-245.6 -71.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.473 17.887)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.954,85.913h-5.6a.433.433,0,0,1-.459-.459v-5.6a.433.433,0,0,1,.459-.459h5.6a.433.433,0,0,1,.459.459v5.6A.491.491,0,0,1,242.954,85.913ZM237.817,84.9H242.5V80.226h-4.678Z",
    transform: "translate(-236.9 -79.4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.443 17.887)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M261.454,85.913h-5.6a.433.433,0,0,1-.459-.459v-5.6a.433.433,0,0,1,.459-.459h5.6a.433.433,0,0,1,.459.459v5.6A.491.491,0,0,1,261.454,85.913ZM256.317,84.9H261V80.226h-4.678Z",
    transform: "translate(-255.4 -79.4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.401 28.436)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M266.993,98.422H228.559a.477.477,0,0,1-.367-.183.687.687,0,0,1-.092-.459l2.477-6.6a.5.5,0,0,1,.459-.275h33.481a.5.5,0,0,1,.459.275l2.477,6.6c.092.183,0,.275-.092.459A.477.477,0,0,1,266.993,98.422ZM229.2,97.5h37.058l-2.11-5.687H231.311Z",
    transform: "translate(-228.1 -90.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.565 41.461)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M244.98,119.593a.433.433,0,0,1-.459-.459V106.109h-6.6v13.025a.459.459,0,1,1-.917,0V105.559a.433.433,0,0,1,.459-.459h7.522a.433.433,0,0,1,.459.459v13.576A.491.491,0,0,1,244.98,119.593Z",
    transform: "translate(-237 -105.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.224 38.893)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M261.074,110.556h-9.815a.433.433,0,0,1-.459-.459v-7.338a.433.433,0,0,1,.459-.459h9.815a.433.433,0,0,1,.459.459V110.1C261.624,110.28,261.349,110.556,261.074,110.556Zm-9.265-1.009h8.806v-6.329h-8.806Z",
    transform: "translate(-250.8 -102.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.315 40.361)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M261.082,104.817h-9.723a.459.459,0,1,1,0-.917h9.723a.433.433,0,0,1,.459.459A.491.491,0,0,1,261.082,104.817Z",
    transform: "translate(-250.9 -103.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.473 19.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.954,81.717h-5.6a.459.459,0,1,1,0-.917h5.6a.459.459,0,1,1,0,.917Z",
    transform: "translate(-236.9 -80.8)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.443 19.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M261.454,81.717h-5.6a.459.459,0,0,1,0-.917h5.6a.459.459,0,1,1,0,.917Z",
    transform: "translate(-255.4 -80.8)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.905 2.018)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M234.559,69.989a.433.433,0,0,1-.459-.459V62.559a.433.433,0,0,1,.459-.459h4.678a.433.433,0,0,1,.459.459v3.853a.459.459,0,0,1-.917,0v-3.3h-3.761V69.53A.491.491,0,0,1,234.559,69.989Z",
    transform: "translate(-234.1 -62.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.079)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M238.887,62.835h-4.22a1.449,1.449,0,0,1-1.468-1.468h0a1.449,1.449,0,0,1,1.468-1.468h4.22a1.449,1.449,0,0,1,1.468,1.468h0A1.576,1.576,0,0,1,238.887,62.835Zm-4.22-1.926a.433.433,0,0,0-.459.459h0a.433.433,0,0,0,.459.459h4.22a.433.433,0,0,0,.459-.459h0a.433.433,0,0,0-.459-.459Z",
    transform: "translate(-233.2 -59.9)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseicon);
export default __webpack_public_path__ + "static/media/house.icon.d749993ba490f912eccf686c7ba45f6f.svg";
export { ForwardRef as ReactComponent };